export default "__VITE_ASSET__54786fb6__"